import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Input } from "@angular/core";
import { UtilityService } from "app/_core/services/utility.service";

@Component({
    selector: "selected-address",
    templateUrl: "./selected-address.component.html",
    styleUrls: ["./selected-address.component.scss"],
    standalone: false
})
export class SelectedAddressComponent implements OnInit {
	_address: string;

	@Input() set address(val: string) {
		if (val) {
			this._address = this._util.capitalizeEachWordAndState(val);
		}
	}

	@Output() changeAddressClicked = new EventEmitter();

	constructor(private _util: UtilityService) {}

	ngOnInit() {}

	changeAddress() {
		this.changeAddressClicked.emit();
	}
}
